import { render, staticRenderFns } from "./LeaverRuleForm.vue?vue&type=template&id=604bf942&"
import script from "./LeaverRuleForm.vue?vue&type=script&lang=ts&"
export * from "./LeaverRuleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports